import { useState } from 'react';

export const useAuthLocalStorage = () => {
    const getToken = () => {
        return localStorage.getItem('accessToken');
    };

    const saveToken = (token) => {
        localStorage.setItem('accessToken', token);
    };

    const removeToken = () => {
        localStorage.removeItem('accessToken');
    };

    return { getToken, saveToken, removeToken };
};